import { render, staticRenderFns } from "./mainCenter3.vue?vue&type=template&id=81f47630&scoped=true&"
import script from "./mainCenter3.vue?vue&type=script&lang=js&"
export * from "./mainCenter3.vue?vue&type=script&lang=js&"
import style0 from "./mainCenter3.vue?vue&type=style&index=0&id=81f47630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f47630",
  null
  
)

export default component.exports